"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var CardRowRadioEdit_1 = require("../../../../../../shared/components/editors/CardRowRadioEdit");
var CardRowDateEdit_1 = require("../../../../../../shared/components/editors/CardRowDateEdit");
var TabEditorContainer_1 = require("../../../../../../shared/components/containers/TabEditorContainer");
var CardRowTimeEdit_1 = require("../../../../../../shared/components/editors/CardRowTimeEdit");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var PlayerEditor = /** @class */ (function (_super) {
    __extends(PlayerEditor, _super);
    function PlayerEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        _this.key_affilate = "affilate";
        _this.key_restrictions = "restrictions";
        _this.key_contacts = "contacts";
        return _this;
    }
    PlayerEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AA = this.props.listAffilatesAvail.Subscribe("*", function (id, data) {
            _this.setState({ affilate_avail: data.data });
        });
        this.SID_AP = this.props.listAffilatesPartnersAvail.Subscribe("*", function (id, data) {
            _this.setState({ affilate_partners_avail: data.data });
        });
        this.SID_AO = this.props.listAffilatesPartnersOffersAvail.Subscribe("*", function (id, data) {
            _this.setState({ partners_offers_avail: data.data });
        });
        this.SID_AT = this.props.listAffilatesPartnersTrackersAvail.Subscribe("*", function (id, data) {
            _this.setState({ partners_trackers_avail: data.data });
        });
        this.SID_AZ = this.props.ListGameProviderZones.Subscribe("*", function (id, data) {
            _this.setState({ gws_zones_avail: data.data });
        });
        if (this.props.player) {
            var _item = this.props.data.getById(this.props.player.key);
            if (_item) {
                this.setState({
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    login: _item.login,
                    password: "",
                    name: _item.name,
                    surname: _item.surname,
                    fathername: _item.fathername,
                    email: _item.email,
                    phone: _item.phone,
                    is_locked: _item.is_locked,
                    is_email_confirmed: _item.is_email_confirmed,
                    is_phone_confirmed: _item.is_phone_confirmed,
                    birthday_day: _item.birthday_day,
                    birthday_month: _item.birthday_month,
                    birthday_year: _item.birthday_year,
                    is_verifed: _item.is_verifed,
                    is_cards_allowed: _item.is_cards_allowed,
                    sex: _item.sex,
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    app_language_id: _item.app_language_id,
                    app_language_title: _item.app_language_title,
                    is_use_affilate: _item.is_use_affilate,
                    affilate_id: _item.affilate_id,
                    affilate_title: _item.affilate_title,
                    partner_id: _item.partner_id,
                    partner_login: _item.partner_login,
                    partner_offer_id: _item.partner_offer_id,
                    partner_offer_title: _item.partner_offer_title,
                    is_use_tracker: _item.is_use_tracker,
                    partner_tracker_id: _item.partner_tracker_id,
                    partner_tracker_title: _item.partner_tracker_title,
                    affilate_avail: [],
                    affilate_partners_avail: [],
                    partners_offers_avail: [],
                    partners_trackers_avail: [],
                    is_bot: _item.is_bot,
                    is_self_exclude: _item.is_self_exclude,
                    self_exclude_till_year: _item.self_exclude_till_year,
                    self_exclude_till_month: _item.self_exclude_till_month,
                    self_exclude_till_day: _item.self_exclude_till_day,
                    self_exclude_till_hour: _item.self_exclude_till_hour,
                    self_exclude_till_minute: _item.self_exclude_till_minute,
                    self_exclude_till_second: _item.self_exclude_till_second,
                    is_self_deposit_week_limit: _item.is_self_deposit_week_limit,
                    self_deposit_week_limit_amount: _item.self_deposit_week_limit_amount,
                    description: _item.description,
                    country: _item.country,
                    city: _item.city,
                    address: _item.address,
                    is_agree_on_email_subscription: _item.is_agree_on_email_subscription,
                    is_streamer: _item.is_streamer,
                    is_custom_zone: _item.is_custom_zone,
                    custom_gameprovider_zone_id: _item.custom_gameprovider_zone_id,
                    custom_gameprovider_zone_title: _item.custom_gameprovider_zone_title,
                    gws_zones_avail: [],
                    is_developer: _item.is_developer,
                    profit_status_code: _item.profit_status_code,
                    profit_status_title: _item.profit_status_title,
                    is_disable_profit_status_select: _item.is_disable_profit_status_select,
                    is_ignore_ip_withdrawal_check: _item.is_ignore_ip_withdrawal_check,
                    trust_zone_code: _item.trust_zone_code,
                    trust_zone_title: _item.trust_zone_title,
                    is_trust_zone_static: _item.is_trust_zone_static,
                    is_ignore_firewall_processing: _item.is_ignore_firewall_processing,
                    is_suspicious: _item.is_suspicious,
                    tabKey: this.key_main,
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование игрока"]);
                    _this.props.listAffilatesPartnersAvail.LoadData(_this.state.affilate_id);
                    _this.props.listAffilatesPartnersOffersAvail.LoadDataKeysAreBrandOfferId(_this.state.partner_id);
                    _this.props.listAffilatesPartnersTrackersAvail.LoadData(_this.state.partner_id);
                    _this.props.ListGameProviderZones.LoadDataByBrandAndCurrency(_this.state.brand_id, _this.state.app_currency_id);
                });
            }
        }
        else {
            this.setState({
                brand_id: 0,
                brand_title: "",
                login: "",
                password: "",
                name: "",
                surname: "",
                fathername: "",
                email: "",
                phone: "",
                is_locked: false,
                is_email_confirmed: false,
                is_phone_confirmed: false,
                birthday_day: 26,
                birthday_month: 4,
                birthday_year: 1998,
                is_verifed: false,
                is_cards_allowed: false,
                sex: "M",
                app_currency_id: 0,
                app_currency_title: "",
                app_language_id: 0,
                app_language_title: "",
                affilate_avail: [],
                affilate_partners_avail: [],
                partners_offers_avail: [],
                partners_trackers_avail: [],
                is_use_affilate: false,
                affilate_id: 0,
                affilate_title: "",
                partner_id: 0,
                partner_login: "",
                partner_offer_id: 0,
                partner_offer_title: "",
                is_use_tracker: false,
                partner_tracker_id: 0,
                partner_tracker_title: "",
                is_bot: false,
                is_self_exclude: false,
                self_exclude_till_year: 2019,
                self_exclude_till_month: 1,
                self_exclude_till_day: 1,
                self_exclude_till_hour: 0,
                self_exclude_till_minute: 0,
                self_exclude_till_second: 0,
                is_self_deposit_week_limit: false,
                self_deposit_week_limit_amount: 10000,
                description: "",
                country: "",
                city: "",
                address: "",
                is_agree_on_email_subscription: false,
                is_streamer: false,
                is_custom_zone: false,
                custom_gameprovider_zone_id: 0,
                custom_gameprovider_zone_title: "",
                gws_zones_avail: [],
                is_developer: false,
                profit_status_code: 0,
                profit_status_title: "",
                is_disable_profit_status_select: false,
                is_ignore_ip_withdrawal_check: false,
                trust_zone_code: 0,
                trust_zone_title: "",
                is_trust_zone_static: false,
                is_ignore_firewall_processing: false,
                is_suspicious: false,
                tabKey: this.key_main,
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание игрока"]);
            });
        }
        this.props.listAffilatesAvail.LoadData();
        this.doReSetRules();
    };
    PlayerEditor.prototype.doReSetRules = function () {
        this.setState({
            brand_rules: { isError: false },
            login_rules: { isError: false },
            app_currency_rules: { isError: false },
            app_language_rules: { isError: false },
            password_rules: { isError: false },
            affilate_rules: { isError: false },
            partner_rules: { isError: false },
            partner_offer_rules: { isError: false },
            partner_tracker_rules: { isError: false },
            self_deposit_week_limit_amount_rules: { isError: false },
            custom_gameprovider_zone_rules: { isError: false },
            profit_status_rules: { isError: false },
            trust_zone_rules: { isError: false },
        });
    };
    PlayerEditor.prototype.componentWillUnmount = function () {
        this.props.listAffilatesAvail.UnSubscribe(this.SID_AA);
        this.props.listAffilatesPartnersAvail.UnSubscribe(this.SID_AP);
        this.props.listAffilatesPartnersOffersAvail.UnSubscribe(this.SID_AO);
        this.props.listAffilatesPartnersTrackersAvail.UnSubscribe(this.SID_AT);
        this.props.ListGameProviderZones.UnSubscribe(this.SID_AZ);
    };
    PlayerEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditPlayer({
                key: this.props.player.key,
                name: this.state.name,
                surname: this.state.surname,
                fathername: this.state.fathername,
                email: this.state.email,
                phone: this.state.phone,
                birthday_day: this.state.birthday_day,
                birthday_month: this.state.birthday_month,
                birthday_year: this.state.birthday_year,
                is_cards_allowed: this.state.is_cards_allowed,
                is_email_confirmed: this.state.is_email_confirmed,
                is_phone_confirmed: this.state.is_phone_confirmed,
                is_verifed: this.state.is_verifed,
                is_locked: this.state.is_locked,
                sex: this.state.sex,
                is_self_exclude: this.state.is_self_exclude,
                self_exclude_till_year: this.state.self_exclude_till_year,
                self_exclude_till_month: this.state.self_exclude_till_month,
                self_exclude_till_day: this.state.self_exclude_till_day,
                self_exclude_till_hour: this.state.self_exclude_till_hour,
                self_exclude_till_minute: this.state.self_exclude_till_minute,
                self_exclude_till_second: this.state.self_exclude_till_second,
                is_self_deposit_week_limit: this.state.is_self_deposit_week_limit,
                self_deposit_week_limit_amount: this.state.self_deposit_week_limit_amount,
                description: this.state.description,
                language_id: this.state.app_language_id,
                country: this.state.country,
                city: this.state.city,
                address: this.state.address,
                is_use_affilate: this.state.is_use_affilate,
                affilate_id: this.state.affilate_id,
                partner_id: this.state.partner_id,
                partner_offer_id: this.state.partner_offer_id,
                is_use_tracker: this.state.is_use_tracker,
                partner_tracker_id: this.state.partner_tracker_id,
                is_agree_on_email_subscription: this.state.is_agree_on_email_subscription,
                is_streamer: this.state.is_streamer,
                is_custom_zone: this.state.is_custom_zone,
                custom_gameprovider_zone_id: this.state.custom_gameprovider_zone_id,
                is_developer: this.state.is_developer,
                profit_status_code: this.state.profit_status_code,
                is_ignore_ip_withdrawal_check: this.state.is_ignore_ip_withdrawal_check,
                trust_zone_code: this.state.trust_zone_code,
                is_trust_zone_static: this.state.is_trust_zone_static,
                is_ignore_firewall_processing: this.state.is_ignore_firewall_processing,
                is_suspicious: this.state.is_suspicious
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Игрок изменен!");
            });
        }
    };
    PlayerEditor.prototype.isDataValid = function () {
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({
                brand_rules: {
                    isError: true,
                    errorMessage: "Поле [бренд] не выбрано!"
                },
                tabKey: this.key_main
            });
            return;
        }
        if ((this.state.trust_zone_code <= 0) || (this.state.trust_zone_title.length === 0)) {
            this.setState({
                trust_zone_rules: {
                    isError: true,
                    errorMessage: "Поле [зона доверия] не выбрано!"
                },
                tabKey: this.key_restrictions
            });
            return;
        }
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({
                app_currency_rules: {
                    isError: true,
                    errorMessage: "Поле [валюта] не выбрано!"
                },
                tabKey: this.key_main
            });
            return;
        }
        if ((this.state.app_language_id <= 0) || (this.state.app_language_title.length === 0)) {
            this.setState({
                app_language_rules: {
                    isError: true,
                    errorMessage: "Поле [язык] не выбрано!"
                },
                tabKey: this.key_main
            });
            return;
        }
        if (this.state.is_use_affilate) {
            if ((this.state.affilate_id <= 0) || (this.state.affilate_title.length === 0)) {
                this.setState({
                    affilate_rules: {
                        isError: true,
                        errorMessage: "Поле [аффилейт] не выбрано!"
                    },
                    tabKey: this.key_affilate
                });
                return;
            }
            if ((this.state.partner_id <= 0) || (this.state.partner_login.length === 0)) {
                this.setState({
                    partner_rules: {
                        isError: true,
                        errorMessage: "Поле [партнер] не выбрано!"
                    },
                    tabKey: this.key_affilate
                });
                return;
            }
            if ((this.state.partner_offer_id <= 0) || (this.state.partner_offer_title.length === 0)) {
                this.setState({
                    partner_offer_rules: {
                        isError: true,
                        errorMessage: "Поле [оффер партнера] не выбрано!"
                    },
                    tabKey: this.key_affilate
                });
                return;
            }
            if (this.state.is_use_tracker) {
                if ((this.state.partner_tracker_id <= 0) || (this.state.partner_tracker_title.length === 0)) {
                    this.setState({
                        partner_tracker_rules: {
                            isError: true,
                            errorMessage: "Поле [трекер партнера] не выбрано!"
                        },
                        tabKey: this.key_affilate
                    });
                    return;
                }
            }
        }
        if (this.state.is_custom_zone) {
            if ((this.state.custom_gameprovider_zone_id <= 0) || (this.state.custom_gameprovider_zone_title.length === 0)) {
                this.setState({
                    custom_gameprovider_zone_rules: {
                        isError: true,
                        errorMessage: "Поле [зона провайдера] не выбрано!"
                    },
                    tabKey: this.key_main
                });
                return;
            }
        }
        if ((!this.state.login) || (this.state.login.length === 0)) {
            this.setState({
                login_rules: {
                    isError: true,
                    errorMessage: "Поле [логин] не заполнено!"
                },
                tabKey: this.key_main
            });
            return;
        }
        if (!this.isOpen4Edit()) {
            if ((!this.state.password) || (this.state.password.length === 0)) {
                this.setState({
                    password_rules: {
                        isError: true,
                        errorMessage: "Поле [пароль] не заполнено!"
                    },
                    tabKey: this.key_main
                });
                return;
            }
        }
        if (this.state.is_self_deposit_week_limit) {
            if (this.state.self_deposit_week_limit_amount <= 0) {
                this.setState({
                    self_deposit_week_limit_amount_rules: {
                        isError: true,
                        errorMessage: "Поле [Лимит депозита] имеет некорректное значение!"
                    },
                    tabKey: this.key_restrictions
                });
            }
            return false;
        }
        if (!this.state.is_disable_profit_status_select) {
            if ((this.state.profit_status_code <= 0) || (this.state.profit_status_title.length === 0)) {
                this.setState({
                    profit_status_rules: {
                        isError: true,
                        errorMessage: "Поле [тип игрока] не выбрано!"
                    },
                    tabKey: this.key_main
                });
                return;
            }
        }
        return true;
    };
    PlayerEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddPlayer({
                brand_id: this.state.brand_id,
                login: this.state.login,
                password: this.state.password,
                name: this.state.name,
                surname: this.state.surname,
                fathername: this.state.fathername,
                email: this.state.email,
                phone: this.state.phone,
                is_locked: this.state.is_locked,
                is_email_confirmed: this.state.is_email_confirmed,
                is_phone_confirmed: this.state.is_phone_confirmed,
                birthday_day: this.state.birthday_day,
                birthday_month: this.state.birthday_month,
                birthday_year: this.state.birthday_year,
                is_verifed: this.state.is_verifed,
                is_cards_allowed: this.state.is_cards_allowed,
                sex: this.state.sex,
                currency_id: this.state.app_currency_id,
                language_id: this.state.app_language_id,
                is_bot: this.state.is_bot,
                is_self_exclude: this.state.is_self_exclude,
                self_exclude_till_year: this.state.self_exclude_till_year,
                self_exclude_till_month: this.state.self_exclude_till_month,
                self_exclude_till_day: this.state.self_exclude_till_day,
                self_exclude_till_hour: this.state.self_exclude_till_hour,
                self_exclude_till_minute: this.state.self_exclude_till_minute,
                self_exclude_till_second: this.state.self_exclude_till_second,
                is_self_deposit_week_limit: this.state.is_self_deposit_week_limit,
                self_deposit_week_limit_amount: this.state.self_deposit_week_limit_amount,
                description: this.state.description,
                country: this.state.country,
                city: this.state.city,
                address: this.state.address,
                is_use_affilate: this.state.is_use_affilate,
                affilate_id: this.state.affilate_id,
                partner_id: this.state.partner_id,
                partner_offer_id: this.state.partner_offer_id,
                is_use_tracker: this.state.is_use_tracker,
                partner_tracker_id: this.state.partner_tracker_id,
                is_agree_on_email_subscription: this.state.is_agree_on_email_subscription,
                is_streamer: this.state.is_streamer,
                is_custom_zone: this.state.is_custom_zone,
                custom_gameprovider_zone_id: this.state.custom_gameprovider_zone_id,
                is_developer: this.state.is_developer,
                profit_status_code: this.state.profit_status_code,
                is_ignore_ip_withdrawal_check: this.state.is_ignore_ip_withdrawal_check,
                trust_zone_code: this.state.trust_zone_code,
                is_trust_zone_static: this.state.is_trust_zone_static,
                is_ignore_firewall_processing: this.state.is_ignore_firewall_processing,
                is_suspicious: this.state.is_suspicious
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Игрок создан!");
            });
        }
    };
    PlayerEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PlayerEditor.prototype.getFormTitle = function () {
        if (!this.props.player) {
            return "Новый игрок";
        }
        else {
            return "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u0430 - [" + this.props.player.login + "]";
        }
    };
    PlayerEditor.prototype.isOpen4Edit = function () {
        if (!this.props.player) {
            return false;
        }
        else {
            return true;
        }
    };
    PlayerEditor.prototype.isGwsAffilateIdDisabled = function () {
        if (this.props.player) {
            return true;
        }
        else {
            return !this.state.is_use_affilate;
        }
    };
    PlayerEditor.prototype.doGeneratePassWord = function () {
        var _this = this;
        this.props.data.GeneratePlayerPassword(function (pwd) {
            _this.setState({ password: pwd }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Пароль сгенерирован!");
            });
        });
    };
    PlayerEditor.prototype.getContactsContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Страна:", placeholder: "Введите страну" }, value: this.state.country, onValueChanged: function (newVal) {
                    _this.setState({
                        country: newVal,
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Город:", placeholder: "Введите город" }, value: this.state.city, onValueChanged: function (newVal) {
                    _this.setState({
                        city: newVal,
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Адрес:", placeholder: "Введите адрес" }, value: this.state.address, onValueChanged: function (newVal) {
                    _this.setState({
                        address: newVal,
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "EMail подтвержден", value: this.state.is_email_confirmed, onChecked: function (checked) {
                    _this.setState({ is_email_confirmed: checked });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Игрок подписан на EMail уведомления", value: this.state.is_agree_on_email_subscription, onChecked: function (checked) { _this.setState({ is_agree_on_email_subscription: checked }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Email игрока:", placeholder: "Введите Email игрока" }, value: this.state.email, onValueChanged: function (newVal) {
                    _this.setState({ email: newVal });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Телефон подтвержден", value: this.state.is_phone_confirmed, onChecked: function (checked) {
                    _this.setState({ is_phone_confirmed: checked });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Телефон игрока:", placeholder: "Введите телефон игрока" }, value: this.state.phone, onValueChanged: function (newVal) {
                    _this.setState({ phone: newVal });
                } }),
            this.getDownButtons()));
    };
    PlayerEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Логин игрока:", placeholder: "Введите логин" }, value: this.state.login, onValueChanged: function (newVal) {
                    _this.setState({
                        login: newVal,
                        login_rules: { isError: false }
                    });
                }, disabled: this.isOpen4Edit(), required: true, rules: this.state.login_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: {
                    caption: "Пароль игрока:",
                    placeholder: "Введите пароль",
                    buttonHint: "Сгенерировать пароль"
                }, disabled: this.isOpen4Edit(), onButtonClick: this.doGeneratePassWord.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        password: newVal,
                        password_rules: { isError: false }
                    });
                }, value: this.state.password, buttonIcon: "key", required: !this.isOpen4Edit(), rules: this.state.password_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд :", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        gws_zones_avail: [],
                        custom_gameprovider_zone_id: 0,
                        custom_gameprovider_zone_title: "",
                        brand_rules: { isError: false }
                    }, function () {
                        _this.props.ListGameProviderZones.LoadDataByBrandAndCurrency(_this.state.brand_id, _this.state.app_currency_id);
                    });
                }, items: this.props.brandsAvail, disabled: this.isOpen4Edit(), required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта :", placeholder: "Выберите валюту" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false },
                        gws_zones_avail: [],
                        custom_gameprovider_zone_id: 0,
                        custom_gameprovider_zone_title: ""
                    }, function () {
                        _this.props.ListGameProviderZones.LoadDataByBrandAndCurrency(_this.state.brand_id, _this.state.app_currency_id);
                    });
                }, items: this.props.appCurrencyAvail, disabled: this.isOpen4Edit(), required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык :", placeholder: "Выберите язык" }, value: { key: this.state.app_language_id, value: this.state.app_language_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_language_id: newVal.key,
                        app_language_title: newVal.value,
                        app_language_rules: { isError: false }
                    });
                }, items: this.props.appLanguageAvail, required: true, rules: this.state.app_language_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Этот игрок является стримером", value: this.state.is_streamer, onChecked: function (checked) { _this.setState({ is_streamer: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Отдельная игровая зона", value: this.state.is_custom_zone, onChecked: function (checked) { _this.setState({ is_custom_zone: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Игровая зона :", placeholder: "Выберите игровую зону" }, value: { key: this.state.custom_gameprovider_zone_id, value: this.state.custom_gameprovider_zone_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        custom_gameprovider_zone_id: newVal.key,
                        custom_gameprovider_zone_title: newVal.value,
                        custom_gameprovider_zone_rules: { isError: false }
                    });
                }, items: this.state.gws_zones_avail, required: this.state.is_custom_zone, disabled: !this.state.is_custom_zone, rules: this.state.custom_gameprovider_zone_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Финансовый профиль :", placeholder: "Выберите финансовый профиль" }, value: { key: this.state.profit_status_code, value: this.state.profit_status_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        profit_status_code: newVal.key,
                        profit_status_title: newVal.value,
                        profit_status_rules: { isError: false }
                    });
                }, items: this.props.usr_behaviors_avail, 
                //required
                rules: this.state.profit_status_rules, disabled: this.state.is_disable_profit_status_select }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Игрок заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            this.getDownButtons()));
    };
    PlayerEditor.prototype.isEditMode = function () {
        if (this.props.player) {
            return true;
        }
        else {
            return false;
        }
    };
    PlayerEditor.prototype.getAdditionalEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Имя игрока:", placeholder: "Введите имя игрока" }, value: this.state.name, onValueChanged: function (newVal) {
                    _this.setState({
                        name: newVal
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Фамилия игрока:", placeholder: "Введите фамилию игрока" }, value: this.state.surname, onValueChanged: function (newVal) { _this.setState({ surname: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Отчество игрока:", placeholder: "Введите отчество игрока" }, value: this.state.fathername, onValueChanged: function (newVal) { _this.setState({ fathername: newVal }); } }),
            React.createElement(CardRowRadioEdit_1.default, { items: [{ key: "M", title: "Мужской" }, { key: "F", title: "Женский" }], value: this.state.sex, onValueChanged: function (newVal) { _this.setState({ sex: newVal }); }, title: "Пол игрока: " }),
            React.createElement(CardRowDateEdit_1.default, { texts: { caption: "Дата рождения", placeholder: "Выберите дату" }, value: {
                    day: this.state.birthday_day,
                    month: this.state.birthday_month,
                    year: this.state.birthday_year
                }, onValueChanged: function (year, month, day) {
                    _this.setState({
                        birthday_day: day,
                        birthday_month: month,
                        birthday_year: year
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Игрок верифицирован", value: this.state.is_verifed, onChecked: function (checked) { _this.setState({ is_verifed: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Этот игрок является ботом", value: this.state.is_bot, onChecked: function (checked) { _this.setState({ is_bot: checked }); }, disabled: this.isEditMode() }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Этот игрок является разработчиком", value: this.state.is_developer, onChecked: function (checked) { _this.setState({ is_developer: checked }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal,
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Подозрительный игрок", value: this.state.is_suspicious, onChecked: function (checked) { _this.setState({ is_suspicious: checked }); } }),
            this.getDownButtons()));
    };
    PlayerEditor.prototype.getAffilateEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Привязан к партнерской программе", value: this.state.is_use_affilate, onChecked: function (checked) {
                    _this.setState({
                        is_use_affilate: checked
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "П.Программа :", placeholder: "Выберите партнерскую программу" }, value: { key: this.state.affilate_id, value: this.state.affilate_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        affilate_id: newVal.key,
                        affilate_title: newVal.value,
                        affilate_rules: { isError: false }
                    }, function () {
                        _this.setState({
                            partners_offers_avail: [],
                            partners_trackers_avail: [],
                            affilate_partners_avail: []
                        }, function () {
                            _this.props.listAffilatesPartnersAvail.LoadData(_this.state.affilate_id);
                        });
                    });
                }, items: this.state.affilate_avail, disabled: !this.state.is_use_affilate, required: this.state.is_use_affilate, rules: this.state.affilate_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Партнер:", placeholder: "Выберите партнера" }, value: { key: this.state.partner_id, value: this.state.partner_login }, onValueChanged: function (newVal) {
                    _this.setState({
                        partner_id: newVal.key,
                        partner_login: newVal.value,
                        partner_rules: { isError: false }
                    }, function () {
                        _this.setState({
                            partners_offers_avail: [],
                            partners_trackers_avail: [],
                        }, function () {
                            _this.props.listAffilatesPartnersOffersAvail.LoadDataKeysAreBrandOfferId(_this.state.partner_id);
                            _this.props.listAffilatesPartnersTrackersAvail.LoadData(_this.state.partner_id);
                        });
                    });
                }, items: this.state.affilate_partners_avail, disabled: !this.state.is_use_affilate, required: this.state.is_use_affilate, rules: this.state.partner_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Оффер партнера :", placeholder: "Выберите оффер партнера" }, value: { key: this.state.partner_offer_id, value: this.state.partner_offer_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        partner_offer_id: newVal.key,
                        partner_offer_title: newVal.value,
                        partner_offer_rules: { isError: false }
                    });
                }, items: this.state.partners_offers_avail, disabled: !this.state.is_use_affilate, required: this.state.is_use_affilate, rules: this.state.partner_offer_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Использовать трекер", value: this.state.is_use_tracker, onChecked: function (checked) {
                    _this.setState({
                        is_use_tracker: checked
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Трекер партнера :", placeholder: "Выберите трекер партнера" }, value: { key: this.state.partner_tracker_id, value: this.state.partner_tracker_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        partner_tracker_id: newVal.key,
                        partner_tracker_title: newVal.value,
                        partner_tracker_rules: { isError: false }
                    });
                }, items: this.state.partners_trackers_avail, disabled: !this.state.is_use_affilate, required: this.state.is_use_affilate, rules: this.state.partner_tracker_rules }),
            this.getDownButtons()));
    };
    PlayerEditor.prototype.getRestrictionEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Оплата картами разрешена", value: this.state.is_cards_allowed, onChecked: function (checked) { _this.setState({ is_cards_allowed: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Самоисключение", value: this.state.is_self_exclude, onChecked: function (checked) {
                    _this.setState({
                        is_self_exclude: checked
                    });
                } }),
            React.createElement(CardRowDateEdit_1.default, { texts: { caption: "Дата окончания", placeholder: "Дата окончания самоисключения" }, value: {
                    day: this.state.self_exclude_till_day,
                    month: this.state.self_exclude_till_month,
                    year: this.state.self_exclude_till_year
                }, onValueChanged: function (year, month, day) {
                    _this.setState({
                        self_exclude_till_day: day,
                        self_exclude_till_month: month,
                        self_exclude_till_year: year
                    });
                }, disabled: !this.state.is_self_exclude }),
            React.createElement(CardRowTimeEdit_1.default, { texts: { caption: "Время окончания", placeholder: "Время окончания самоисключения" }, value: {
                    hour: this.state.self_exclude_till_hour,
                    minute: this.state.self_exclude_till_minute,
                    second: this.state.self_exclude_till_second
                }, onValueChanged: function (hour, minute, second) {
                    _this.setState({
                        self_exclude_till_hour: hour,
                        self_exclude_till_minute: minute,
                        self_exclude_till_second: second
                    });
                }, disabled: !this.state.is_self_exclude }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Недельный лимит депозита", value: this.state.is_self_deposit_week_limit, onChecked: function (checked) {
                    _this.setState({
                        is_self_deposit_week_limit: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Максимальный депозит:", placeholder: "Введите максимальный лимит депозита" }, values: { max: 99999999999, min: 1, value: this.state.self_deposit_week_limit_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        self_deposit_week_limit_amount: newVal,
                        self_deposit_week_limit_amount_rules: { isError: false }
                    });
                }, required: true, precision: 0, disabled: !this.state.is_self_deposit_week_limit, rules: this.state.self_deposit_week_limit_amount_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Игнорировать проверку выплат по ip", value: this.state.is_ignore_ip_withdrawal_check, onChecked: function (checked) {
                    _this.setState({
                        is_ignore_ip_withdrawal_check: checked
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Доверенная зона:", placeholder: "Выберите доверенную зону" }, value: { key: this.state.trust_zone_code, value: this.state.trust_zone_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        trust_zone_code: newVal.key,
                        trust_zone_title: newVal.value,
                        trust_zone_rules: { isError: false }
                    });
                }, items: this.props.trust_zones_avail, required: true, rules: this.state.trust_zone_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Доверенная зона статична", value: this.state.is_trust_zone_static, onChecked: function (checked) {
                    _this.setState({
                        is_trust_zone_static: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Игнорировать проверку игрока через firewall", value: this.state.is_ignore_firewall_processing, onChecked: function (checked) {
                    _this.setState({
                        is_ignore_firewall_processing: checked
                    });
                } }),
            this.getDownButtons()));
    };
    PlayerEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.player != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    PlayerEditor.prototype.onTabChange = function (key) {
        this.setState({ tabKey: key });
    };
    PlayerEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainEditContent();
        }
        if (this.state.tabKey === this.key_additional) {
            return this.getAdditionalEditContent();
        }
        if (this.state.tabKey === this.key_affilate) {
            return this.getAffilateEditContent();
        }
        if (this.state.tabKey === this.key_restrictions) {
            return this.getRestrictionEditContent();
        }
        if (this.state.tabKey === this.key_contacts) {
            return this.getContactsContent();
        }
        return null;
    };
    PlayerEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 720, activeTabKey: this.state.tabKey, tabs: [
                { key: this.key_main, tab: "Основные" },
                { key: this.key_additional, tab: "Дополнительно" },
                { key: this.key_affilate, tab: "П.Программа" },
                { key: this.key_restrictions, tab: "Ограничения" },
                { key: this.key_contacts, tab: "Контакты" },
            ], onTabChange: function (key) { _this.onTabChange(key); } }, this.getContent()));
    };
    return PlayerEditor;
}(React.Component));
exports.default = PlayerEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/PlayerEditor.tsx
// module id = 1920
// module chunks = 0